import React, { ReactNode } from "react"

import classNames from "classnames"
import { colorOptions } from "../../../types"
import { twMerge } from "tailwind-merge"
import { ContainerType } from "./container"

export enum CardBackgroundColor {
    "White" = "#fff",
    "Green" = "#919a76",
    "Grey" = "#f7f4f3",
}

interface ShadowCardProps {
    children: ReactNode
    background?: CardBackgroundColor
    className?: string
    type?: ContainerType
}

const ShadowCard = ({ children, className, background = CardBackgroundColor.White, type }: ShadowCardProps) => {
    return (
        <div
            className={twMerge(
                classNames(
                    "mx-auto flex w-full flex-col rounded-base p-5 sm:p-7.5 lg:w-[80%] lg:p-15",
                    {
                        "bg-white shadow-base lg:shadow-lg": background === CardBackgroundColor.White,
                        "bg-linear-to-r from-green-dark via-green-light to-green-dark shadow-base lg:shadow-lg":
                            background === CardBackgroundColor.Green,
                        "bg-background-tide p-7 sm:p-10 lg:p-16": background === CardBackgroundColor.Grey,
                        "lg:w-full": type === ContainerType.Article,
                    },
                    className
                )
            )}
        >
            {children}
        </div>
    )
}

export const cardBackgroundOptions = colorOptions<typeof CardBackgroundColor>(CardBackgroundColor)

export default ShadowCard
